import xlsx, { ISettings, IJsonSheet, IColumn, IContent } from "json-as-xlsx";
import moment from "moment";
import {
  RelatorioPortariaPdfResponse,
  RelatorioPortariaItem,
} from "core/features/portaria/typings";
import { defaultContentMapperXlsx } from "infra/packages/json-as-xlsx/index";
import { formatBlocoQuadra } from "infra/helpers/formatBlocoQuadra";

export function exportExcelRelatorioPortaria({
  data,
}: {
  data: RelatorioPortariaPdfResponse;
}) {
  const periodo = data.periodo?.replace("/", "_");
  const settings: ISettings = {
    fileName: `Relatório de portarias confirmadas - ${periodo}`,
    extraLength: 3,
    writeOptions: {},
  };

  const columns = getColumns({
    includePessoaAcao: data.items.some((item) => !!item.pessoaAcao),
  });

  const sheets: IJsonSheet[] = [];

  sheets.push({
    sheet: "Portarias",
    columns: columns,
    content: data.items.map(defaultContentMapperXlsx),
  });

  xlsx(sheets, settings);
}

function getColumns({ includePessoaAcao }: { includePessoaAcao?: boolean }) {
  const columns: IColumn[] = [];

  columns.push({
    label: "Unidade",
    value: (row: IContent) => {
      const { unidade, blocoQuadra } = row as unknown as RelatorioPortariaItem;

      return `${formatBlocoQuadra(unidade?.numero, blocoQuadra?.nome)}`;
    },
  });

  columns.push({
    label: "Quem entrou",
    value: (row: IContent) =>
      (row as unknown as RelatorioPortariaItem).pessoa?.nome ?? "--",
  });

  columns.push({
    label: "Responsável",
    value: (row: IContent) =>
      (row as unknown as RelatorioPortariaItem).pessoaResponsavel?.nome ?? "--",
  });

  if (includePessoaAcao) {
    columns.push({
      label: "Quem confirmou",
      value: (row: IContent) =>
        (row as unknown as RelatorioPortariaItem).pessoaAcao?.nome ?? "--",
    });
  }

  columns.push({
    label: "Data de entrada",
    format: "dd/mm/yyyy hh:mm",
    value: (row: IContent) => {
      const data = (row as unknown as RelatorioPortariaItem).data;

      return data ? moment(data).format("DD/MM/YYYY HH:mm") : "--";
    },
  });

  return columns;
}
